/**
 * A class which is used with the isExtensionOf function to determine
 * if a value is a constructable function
 */
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export abstract class Constructable {

}
